import React, { useMemo } from 'react';

import { AudioListenButton } from '@atlassian/ai-audio';

import { useAudioContentQuery } from '@confluence/audio/entry-points/useAudioContentQuery';

type AudioListenButtonWrapperProps = {
	isRovoButtonEnabled: boolean;
	contentId: string;
	contentType: string;
	spaceKey: string;
	title: string;
};

export const AudioListenButtonWrapper = ({
	isRovoButtonEnabled,
	contentId,
	contentType,
	spaceKey,
	title,
}: AudioListenButtonWrapperProps) => {
	const { data } = useAudioContentQuery({ contentId });

	const ownerName = data?.singleContent?.history?.ownedBy?.displayName;
	const authorName = data?.singleContent?.history?.createdBy?.displayName;
	const ownerAvatarUrl = data?.singleContent?.history?.ownedBy?.profilePicture?.path;
	const authorAvatarUrl = data?.singleContent?.history?.createdBy?.profilePicture?.path;

	const shouldUsePageOwner = ownerName && contentType === 'page';
	const contentAvatarName = shouldUsePageOwner ? ownerName : authorName;
	const contentAvatarUrl = shouldUsePageOwner ? ownerAvatarUrl : authorAvatarUrl;

	const activeContent = useMemo(
		() => ({
			contentId,
			contentType,
			spaceKey,
			title,
			author: contentAvatarName,
			avatarUrl: contentAvatarUrl,
		}),
		[contentId, contentType, spaceKey, title, contentAvatarName, contentAvatarUrl],
	);

	return (
		<AudioListenButton
			shape={isRovoButtonEnabled ? 'default' : 'circle'}
			activeContent={activeContent}
		/>
	);
};
